module.exports = __webpack_public_path__ + "static/media/Score Rank.ff63300c.svg";